module.exports = __webpack_public_path__ + "media/12_18.88f784c4.wav";